/* ==========================================================================
   TNF · Bestaetigung im Warenkorb-Drawer
   --------------------------------------------------------------------------
   Halo oeffnet den Drawer nach dem Hinzufuegen bereits selbst. Was fehlt, ist
   die Rueckmeldung WAS gerade hineingelegt wurde - ohne sie muss der Kunde die
   Liste absuchen, um sicher zu sein, dass der Klick angekommen ist.

   Ablauf:
   1. Klick auf eine Warenkorb-Schaltflaeche merken und den Produktnamen aus
      der umgebenden Kachel bzw. der Produktseite ziehen.
   2. Auf Halos 'cart-update'-Ereignis warten, das nach dem Nachladen des
      Drawer-Inhalts ausgeloest wird.
   3. Streifen einblenden, nach acht Sekunden wieder schliessen.

   Der Streifen wird nur nach einem echten Klick auf "In den Warenkorb"
   gezeigt, nicht beim Mengenaendern oder beim Oeffnen ueber das Kopfsymbol.
   ========================================================================== */
(function () {
  'use strict';

  var PENDING = null;
  var TIMER = null;

  function titleFromButton(btn) {
    var card = btn.closest('.product-item');
    if (card) {
      var t = card.querySelector('.card-title');
      if (t) return t.textContent.trim();
    }
    var page = document.querySelector('.product__title, .product-single__title, h1');
    return page ? page.textContent.trim() : '';
  }

  function imageFromButton(btn) {
    var card = btn.closest('.product-item');
    var img = card ? card.querySelector('.card-media img') : document.querySelector('#pdpMain, .product__media img');
    return img ? img.getAttribute('src') : '';
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-btn-addToCart], .button-ATC, .product-form__submit');
      if (!btn || btn.hasAttribute('disabled')) return;
      // Quick-Shop und "Optionen waehlen" fuehren erst auf die Produktseite.
      if (btn.hasAttribute('data-quickshop-popup') || btn.classList.contains('is-notify-me')) return;
      PENDING = { title: titleFromButton(btn), image: imageFromButton(btn) };
    },
    true
  );

  function removeRow() {
    var row = document.querySelector('.tnf-dr-added');
    if (!row) return;
    row.classList.remove('is-open');
    // Erst nach dem Zufahren aus dem DOM nehmen, sonst springt das Layout.
    setTimeout(function () {
      if (row.parentNode) row.parentNode.removeChild(row);
    }, 420);
  }

  function buildRow(panel, data) {
    var existing = panel.querySelector('.tnf-dr-added');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var row = document.createElement('div');
    row.className = 'tnf-dr-added is-mounted';
    row.setAttribute('role', 'status');
    row.innerHTML =
      '<div class="tnf-dr-added__in">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
      '<div><b>Zum Warenkorb hinzugefügt</b><span></span></div>' +
      '</div>';
    row.querySelector('span').textContent = data.title || '';

    var header = panel.querySelector('.halo-sidebar-header');
    if (header && header.nextSibling) {
      panel.insertBefore(row, header.nextSibling);
    } else {
      panel.appendChild(row);
    }
    return row;
  }

  document.addEventListener('cart-update', function () {
    if (!PENDING) return;
    var panel = document.getElementById('halo-cart-sidebar');
    if (!panel) {
      PENDING = null;
      return;
    }
    var row = buildRow(panel, PENDING);
    PENDING = null;

    // Zwei Frames warten, damit der Uebergang von 0fr auf 1fr wirklich laeuft.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        row.classList.add('is-open');
      });
    });

    clearTimeout(TIMER);
    TIMER = setTimeout(removeRow, 8000);
  });

  // Beim Schliessen des Drawers verschwindet die Zeile sofort, damit sie beim
  // naechsten Oeffnen nicht als leerer Streifen stehen bleibt.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-close-cart-sidebar], .background-overlay')) return;
    clearTimeout(TIMER);
    removeRow();
  });

  /* ------------------------------------------------------------------------
     Werkzeugleiste mit der Tastatur bedienbar machen
     ------------------------------------------------------------------------
     Halo baut Notiz, Versand und Gutschein als <div> mit Klick-Handler. Ein
     div hoert auf keine Taste. snippets/halo-side-cart.liquid gibt ihnen
     role="button" und tabindex, hier kommt das dazu, was ein echter Button
     mitbraechte: Enter und Leertaste loesen aus.
     ------------------------------------------------------------------------ */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var item = e.target.closest && e.target.closest('.cartTool-item[role="button"]');
    if (!item) return;
    e.preventDefault();
    item.click();
  });
})();
